import React, {useState, useEffect, useContext} from "react";
import {registerLocale} from "react-datepicker";
import * as Yup from "yup";
import {it} from "date-fns/locale";
import {TranslateContext} from "../../../context/TranslateContext";
import {
    aggiornaTipoImpExpDatiApi, aggiungiTipoImpExpDatiApi,
    getClassiTipiImpExpDatiApi,
    getTipiImpExpDatiPadriApi
} from "../services/TipiImpExpDatiServices";
import FormModificaTipoImpExpView from "./FormModificaTipoImpExpView";

registerLocale('it', it)

export default function FormModificaTipoImpExpController({
                                                             id,
                                                             idClasse,
                                                             formikRef,
                                                             history,
                                                             principale,
                                                             organizzazione = null,
                                                             padre = null,
                                                             addFiglio = false
                                                         }) {

    const [tipoImpExp, setTipoImpExp] = useState(organizzazione);
    const [optionsClassi, setOptionsClassi] = useState([]);
    const [optionsPadri, setOptionsPadri] = useState([]);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [nuovoPadre, setNuovoPadre] = useState(padre);
    const {translate} = useContext(TranslateContext);

    const getPadri = async (idClasse) => {
        if (idClasse) {
            const response = await getTipiImpExpDatiPadriApi(idClasse)
            let val = response.data.data;
            if (val) {
                setOptionsPadri(val);
            }
        }
    }

    async function getClassi() {
        let params = ''

        if (!id || addFiglio === true) {
            // non ho id: l'oggetto è nuovo, devo restituire le classi root o le classi compatibili con il padre
            if (principale === true) {
                params = '?idClPadre=' + (idClasse || '');
            }
        } else if (organizzazione) {
            // ho id: sono in update, aspetto di avere l'oggetto e recupero le classi compatibili con padre e figli
            let idObjPadre = (nuovoPadre && nuovoPadre.id_tipo_imp_exp_dati_padre) || organizzazione.id_tipo_imp_exp_dati_padre;
            params = organizzazione.id_tipo_imp_exp_dati_padre ? '?idEl=' + id + '&idElPadre=' + idObjPadre : '';
        }

        const response = await getClassiTipiImpExpDatiApi(params);
        setOptionsClassi(response.data.data);
    }

    useEffect(() => {
        setTipoImpExp(organizzazione)

        if (id && organizzazione && organizzazione.id_classe_tipo_imp_exp) {
            getPadri(organizzazione.id_classe_tipo_imp_exp)
        }

        // se cambio oggetto padre devo eseguire nuovamente la chiamata visto che potrebbero essere cambiate le classi compatibili
        getClassi();
    }, [id, organizzazione, idClasse, principale, nuovoPadre]);

    const closeModal = () => setShow(false);

    var SignupSchema = Yup.object().shape({
        id_classe_tipo_imp_exp: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
        codice: Yup.string()
            .max(20, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        descrizione: Yup.string()
            .max(200, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio'))
    });

    async function aggiornaTipoImpExpDati(newObj) {
        const response = await aggiornaTipoImpExpDatiApi(id, newObj);
        if (response.data.result === 0) {
            history.goBack()
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiTipoImpExpDati(newObj) {
        const response = await aggiungiTipoImpExpDatiApi(newObj);
        if (response.data.result === 0) {
            history.goBack()
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    function handleCloseModalModifica() {
        setShowConfirm(false)
    }

    function handleOkModalModifica() {
        formikRef.current.setFieldValue('id_tipo_imp_exp_dati_padre', (nuovoPadre && nuovoPadre.id_tipo_imp_exp_dati))
        setShowConfirm(false)
    }

    const initValuesForm = {
        id_tipo_imp_exp_dati: '',
        id_classe_tipo_imp_exp: '',
        classe_tipo_imp_exp: '',
        codice: '',
        descrizione: '',
        canc: '0',
        id_tipo_imp_exp_dati_padre: ''
    };

    function onSubmitForm(values) {
        let newObj = values;

        if (id && !idClasse) {
            aggiornaTipoImpExpDati(newObj);
        } else {
            if (idClasse) {
                newObj['id_tipo_imp_exp_dati_padre'] = id;
            }

            aggiungiTipoImpExpDati(newObj);
        }
    }

    function onChangeTipoImpExpDati(obj) {
        if (obj) {
            if (principale !== true) {
                getPadri(obj.code)
            }
        }
    }

    function onChangeOrganizzazioneMadre(obj) {
        if (id) {
            // Chiedo conferma prima di modificare il padre
            setShowConfirm(true);
        }

        let padriFiltrati = optionsPadri.filter((p) => p.id == obj.code);
        if (padriFiltrati && padriFiltrati.length > 0) {
            setNuovoPadre(padriFiltrati.reduce((p) => p));
        } else {
            setNuovoPadre(null);
        }
    }

    function validateOrganizzazioneMadre(value) {
        if ((!principale || principale === false) && (!value || value === '')) {
            return translate('Questo campo è obbligatorio')
        }
    }

    return (
        <FormModificaTipoImpExpView
            modalMsg={modalMsg}
            showConfirm={showConfirm}
            show={show}
            id={id}
            closeModal={closeModal}
            optionsClassi={optionsClassi}
            translate={translate}
            formikRef={formikRef}
            optionsPadri={optionsPadri}
            addFiglio={addFiglio}
            SignupSchema={SignupSchema}
            principale={principale}
            tipoImpExp={tipoImpExp}
            handleCloseModalModifica={handleCloseModalModifica}
            handleOkModalModifica={handleOkModalModifica}
            initValuesForm={initValuesForm}
            onSubmitForm={onSubmitForm}
            onChangeTipoImpExpDati={onChangeTipoImpExpDati}
            onChangeOrganizzazioneMadre={onChangeOrganizzazioneMadre}
            validateOrganizzazioneMadre={validateOrganizzazioneMadre}
        />
    );
}